const $c22178263632493a$var$ports = [
    {
        slug: "openttd",
        name: "OpenTTD",
        description: "Open-source transport management simulation.",
        path: "/ports/openttd/",
        repoUrl: "https://github.com/msadev/OpenTTD",
        upstreamUrl: "https://github.com/OpenTTD/OpenTTD",
        tags: [
            "multiplayer"
        ]
    },
    {
        slug: "openrct2",
        name: "OpenRCT2",
        description: "Theme park construction and management.",
        path: "/ports/openrct2/",
        repoUrl: "https://github.com/msadev/OpenRCT2",
        upstreamUrl: "https://github.com/OpenRCT2/OpenRCT2",
        tags: [
            "multiplayer",
            "requires original assets"
        ]
    }
];
var $c22178263632493a$export$2e2bcd8739ae039 = $c22178263632493a$var$ports;


const $2b6e161c9edcf319$var$listEl = document.getElementById("ports-list");
const $2b6e161c9edcf319$var$createPortCard = (port)=>{
    const card = document.createElement("article");
    card.className = "port-card";
    const title = document.createElement("h3");
    title.textContent = port.name;
    const tags = document.createElement("div");
    tags.className = "port-tags";
    if (Array.isArray(port.tags) && port.tags.length > 0) port.tags.forEach((tag)=>{
        const tagEl = document.createElement("span");
        const tagLower = tag.toLowerCase();
        if (tagLower.includes("multiplayer")) tagEl.className = "tag tag--multiplayer";
        else if (tagLower.includes("requires")) tagEl.className = "tag tag--requires";
        else tagEl.className = "tag";
        tagEl.textContent = tag;
        tags.appendChild(tagEl);
    });
    const desc = document.createElement("p");
    desc.textContent = port.description;
    const links = document.createElement("div");
    links.className = "port-links";
    const playLink = document.createElement("a");
    playLink.href = port.path;
    playLink.className = "primary";
    playLink.textContent = "Play";
    const repoLink = document.createElement("a");
    repoLink.href = port.repoUrl;
    repoLink.textContent = "Repo";
    repoLink.className = "secondary";
    repoLink.target = "_blank";
    repoLink.rel = "noreferrer";
    const upstreamLink = document.createElement("a");
    upstreamLink.href = port.upstreamUrl;
    upstreamLink.textContent = "Upstream";
    upstreamLink.className = "secondary";
    upstreamLink.target = "_blank";
    upstreamLink.rel = "noreferrer";
    links.append(playLink, repoLink, upstreamLink);
    card.append(title);
    if (tags.childElementCount > 0) card.appendChild(tags);
    card.appendChild(desc);
    card.appendChild(links);
    return card;
};
const $2b6e161c9edcf319$var$renderPorts = (items)=>{
    $2b6e161c9edcf319$var$listEl.innerHTML = "";
    items.forEach((port)=>$2b6e161c9edcf319$var$listEl.appendChild($2b6e161c9edcf319$var$createPortCard(port)));
};
$2b6e161c9edcf319$var$renderPorts((0, $c22178263632493a$export$2e2bcd8739ae039));


//# sourceMappingURL=openwebports.dff1c061.js.map
